import { Avatar } from '@material-ui/core';
import { css } from '@emotion/react';

import { UserSettings } from 'types/userSettings';

import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors';
import { setOpacity } from 'styles/utils';

import { ReactComponent as GirlIcon } from 'public/media/gender/girl_active.svg';
import { ReactComponent as BoyIcon } from 'public/media/gender/boy_active.svg';

const avatarImgCss = (colors: IColors) => css`
	&.MuiAvatar-root {
		background-color: ${setOpacity(colors.bg_text_primary || '', 0.05)};
		width: 100px;
		height: 100px;
		&:hover {
			background-color: ${setOpacity(colors.bg_text_primary || '', 0.1)};
		}
	}
`;

const avatarImgIconCss = (colors: IColors) => css`
	color: ${colors.tx_text_primary};
	&.MuiSvgIcon-root {
		width: 45px;
		height: 45px;
	}
`;

const MemberAvatar = ({ member }: { member: UserSettings }) => {
	const { colors } = useColors();
	return (
		<Avatar css={avatarImgCss(colors)} src={member.profilePicture?.url}>
			{member.gender === 2 && (
				<div css={avatarImgIconCss(colors)}>
					<BoyIcon />
				</div>
			)}
			{member.gender === 3 && (
				<div css={avatarImgIconCss(colors)}>
					<GirlIcon />
				</div>
			)}
		</Avatar>
	);
};

export default MemberAvatar;
